import _ from 'lodash';
import {
    deserialisePeople,
    getCompanyTypeDefinition
} from '../../api/lendingAPI/CustomerStateAPIHelper';

export function isProfileLocation(location) {
    return location.pathname === '/company/';
}

export function setYourCompanyState(action) {
    const { customer_state, payment_method } = action;
    const people = customer_state?.application?.people ?? [];

    return {
        ready: true,

        people: deserialisePeople(people),
        company_name:
            customer_state?.application?.company?.registered_company_name ?? '',
        company_number:
            customer_state?.application?.company?.company_number ?? '',
        annual_turnover:
            customer_state?.application?.company?.last_12_months_turnover
                ?.amount ?? '',
        annual_profit:
            customer_state?.application?.company?.last_12_months_profit
                ?.amount ?? '',
        trading_name: customer_state?.application?.company?.trading_name ?? '',
        industry: customer_state?.application?.company?.industry ?? '',
        trading_from: {
            day: (
                customer_state?.application?.company?.trading_from_date ?? ''
            ).substring(8, 10),
            month: (
                customer_state?.application?.company?.trading_from_date ?? ''
            ).substring(5, 7),
            year: (
                customer_state?.application?.company?.trading_from_date ?? ''
            ).substring(0, 4)
        },
        website: customer_state?.application?.company?.website ?? '',
        paymentMethods: getPaymentMethods(payment_method),
        showAddBankAccountForm: !detectBankAccountLinked(payment_method),
        showAddDebitCardForm: detectDebitCardLinked(payment_method),
        showManualCompany: true, //TODO - change once backend supports editing company
        companyType: getCompanyTypeDefinition(customer_state)
    };
}

export function getPaymentMethods(paymentMethods) {
    if (paymentMethods) {
        return _.chain(paymentMethods)
            .map((paymentMethod) => deserializePaymentMethod(paymentMethod))
            .orderBy(
                (paymentMethod) => [
                    paymentMethod.type === 'card',
                    paymentMethod.isPrimary,
                    paymentMethod.isBackup,
                    paymentMethod.isDisabled
                ],
                'desc'
            )
            .value();
    }
}

export function deserializePaymentMethod(paymentMethod) {
    return {
        paymentMethodID: paymentMethod.payment_method_id,
        cardNumber: formatCardNumber(paymentMethod.last_digits),
        accountNumber: formatAccountNumber(paymentMethod.bank_details),
        sortCode: paymentMethod.bank_details?.sort_code,
        lastDigits: paymentMethod.last_digits,
        isDisabled: paymentMethod.roles.repayment === 'disabled',
        isPrimary: paymentMethod.roles.repayment === 'primary',
        isBackup: paymentMethod.roles.repayment === 'backup',
        repaymentRole: paymentMethod.roles.repayment,
        fundingRole: paymentMethod.roles.funding,
        isFundingDisabled: paymentMethod.roles.funding === 'disabled',
        brand: paymentMethod.brand,
        expiryDateFormatted: formatExpiryDate(paymentMethod.expires),
        type: paymentMethod.payment_method_type,
        issuer: paymentMethod.issuer,
        isWithStripe: isCardAssociatedWithStripe(paymentMethod.token_details)
    };
}

function isCardAssociatedWithStripe(tokenDetails) {
    if (!tokenDetails) return false;
    return tokenDetails.provider === 'stripe';
}

export function formatCardNumber(lastDigits) {
    if (!lastDigits) {
        return null;
    }

    return `XXXX XXXX XXXX ${lastDigits}`;
}

export function formatAccountNumber(bankDetails) {
    if (!bankDetails) {
        return null;
    }

    if (bankDetails.iban) {
        return `XXXX ${bankDetails.iban.slice(-5)}`;
    }

    return bankDetails.account_number;
}

export function formatExpiryDate(expiryDate) {
    if (expiryDate?.month && expiryDate.year) {
        const formattedExpiryDateMonth =
            (expiryDate.month < 10 ? '0' : '') + expiryDate.month;
        const formattedExpiryDateYear = expiryDate.year.toString().slice(-2);
        return `${formattedExpiryDateMonth}/${formattedExpiryDateYear}`;
    }

    return null;
}

function detectPaymentMethod(paymentMethodType) {
    return (paymentMethods) =>
        _.some(paymentMethods, { payment_method_type: paymentMethodType });
}

export function detectBankAccountLinked(paymentMethods) {
    return detectPaymentMethod('bank_account')(paymentMethods);
}
function detectDebitCardLinked(paymentMethods) {
    return detectPaymentMethod('card')(paymentMethods);
}
